module.exports = __webpack_public_path__ + "../resources/images/calinvite-blurred-bg-1a1881712850b9b43253e349668e3e83.jpg";